import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Pagination from '../../../components/Pagination';
import NoticeController, {
  NoticeItemType,
  WeatherNoticeItemType,
} from '../../../controller/NoticeController';

const NoticeIndex = () => {
  const navigate = useNavigate();
  const [noticeList, setNoticeList] = useState<NoticeItemType[]>([]);
  const [weatherNoticeList, setWeatherNoticeList] = useState<WeatherNoticeItemType[]>([]);

  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);
  // 페이지 개수
  const [pageCount, setPageCount] = useState<number>(1);

  // 공지사항 타입  => 0: 일반 공지사항 / 1: 기상안내
  const [noticeType, setNoticeType] = useState<number>(0);

  const onChangeNoticeType = (value: number) => {
    setNoticeType(value);
    setCurrentPage(1);
    setPageCount(1);
  };

  const navigateEdit = async (item?: NoticeItemType) => {
    navigate(`/knock/notice/edit${item ? `/${item.notice_id}` : '/-1'}`, {
      state: { title: item ? item.title : '' },
    });
  };

  const getList = async () => {
    const oParams = {
      item_count: 10,
      page: currentPage,
    };

    const oRes = await NoticeController.getlist(oParams);

    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        setNoticeList([...oResponse.data.list]);
        setPageCount(Math.ceil(oResponse.data.totalCount / 10));
      }
    }
  };

  const deleteItem = async (item: NoticeItemType) => {
    const oParams = {
      notice_id: item.notice_id,
    };

    const oRes = await NoticeController.delete(oParams);

    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        toast.success('공지사항을 삭제했어요.');
        getList();
      } else {
        toast.error('공지사항 삭제 에러');
      }
    }
  };

  const navigateWeatherEdit = async (item?: WeatherNoticeItemType) => {
    navigate(`/knock/notice/weather/edit${item ? `/${item.simple_notice_id}` : '/-1'}`, {
      state: { item },
    });
  };

  const getWeatherList = async () => {
    const oParams = {
      item_count: 10,
      page: currentPage,
    };

    const oRes = await NoticeController.getWeatherNoticeList(oParams);

    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        setWeatherNoticeList([...oResponse.data.list]);
        setPageCount(Math.ceil(oResponse.data.totalCount / 10));
      }
    }
  };

  const deleteWeatherItem = async (item: WeatherNoticeItemType) => {
    const oParams = {
      simple_notice_id: item.simple_notice_id,
    };

    const oRes = await NoticeController.deleteWeatherNoticeList(oParams);

    if (oRes && oRes.data) {
      const oResponse = oRes.data;
      if (oResponse.data) {
        toast.success('기상안내를 삭제했어요.');
        getWeatherList();
      } else {
        toast.error('기상안내 삭제 에러');
      }
    }
  };

  const onDelete = (item: NoticeItemType | WeatherNoticeItemType) => {
    if (noticeType === 0) {
      if (window.confirm('공지사항을 삭제하시겠습니까?')) {
        deleteItem(item as NoticeItemType);
      }
    } else {
      if (window.confirm('기상안내를 삭제하시겠습니까?')) {
        deleteWeatherItem(item as WeatherNoticeItemType);
      }
    }
  };

  useEffect(() => {
    if (noticeType === 0) {
      getList();
    } else {
      getWeatherList();
    }
  }, [noticeType, currentPage]);

  const pressPage = async (selected: { selected: number }) => {
    setCurrentPage(selected.selected + 1);
  };

  const RenderNotice = () => {
    return (
      <>
        <button className="addButton" onClick={() => navigateEdit()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>새 공지사항 등록하기</h4>
        </button>

        {noticeList.length > 0 ? (
          <div className="noticeList">
            {noticeList.map((item: any, index: number) => {
              return <RenderNoticeItem key={index} item={item} index={index} />;
            })}
          </div>
        ) : (
          <div className="noticeList none">
            <h3>공지사항을 등록해주세요</h3>
          </div>
        )}
      </>
    );
  };

  interface ItemProps {
    item: NoticeItemType;
    index: number;
  }

  const RenderNoticeItem = ({ item, index }: ItemProps) => {
    return (
      <div key={index}>
        <div className={`listItem`}>
          <div className="itemTitle">
            <div className="row gap">
              <div className="row">
                <h3>{index + 1}.</h3>
                <h3>{item.title}</h3>
              </div>
            </div>
            <div className="row gap">
              <button onClick={() => navigateEdit(item)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="ic" />
              </button>
              <button onClick={() => onDelete(item)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`} alt="ic" />
              </button>
            </div>
          </div>
          <div className="content">
            <div className="row">
              <h4>게시일자:</h4>
              {item.published_from && <h4>{moment(item.published_from).format('YYYY/MM/DD')}</h4>}
              <h4>~</h4>
              {item.published_to && <h4>{moment(item.published_to).format('YYYY/MM/DD')}</h4>}
            </div>
            <div className="row">
              <h4>{item.is_published ? '게시중' : '미게시'}</h4>
              <div className={`dot ${!item.is_published && 'pause'}`} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderWeatherNotice = () => {
    return (
      <>
        <button className="addButton" onClick={() => navigateWeatherEdit()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>새 기상안내 등록하기</h4>
        </button>

        {weatherNoticeList.length > 0 ? (
          <div className="noticeList">
            {weatherNoticeList.map((item: any, index: number) => {
              return <RenderWeatherNoticeItem key={index} item={item} index={index} />;
            })}
          </div>
        ) : (
          <div className="noticeList none">
            <h3>기상안내를 등록해주세요</h3>
          </div>
        )}
      </>
    );
  };

  interface WeatherItemProps {
    item: WeatherNoticeItemType;
    index: number;
  }

  const RenderWeatherNoticeItem = ({ item, index }: WeatherItemProps) => {
    return (
      <div key={index}>
        <div className={`listItem`}>
          <div className="itemTitle">
            <div className="row gap">
              <div className="row">
                <h3>{index + 1}.</h3>
                <h3>{item.content}</h3>
              </div>
            </div>
            <div className="row gap">
              <div className="row">
                <h4>{item.status ? '게시중' : '미게시'}</h4>
                <div className={`dot ${!item.status && 'pause'}`} />
              </div>
              <button onClick={() => navigateWeatherEdit(item)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="ic" />
              </button>
              <button onClick={() => onDelete(item)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`} alt="ic" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="wrap">
        <div className="contentContainer">
          <button className="backButton" onClick={() => navigate('/dashboard')}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
          </button>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>
              기상안내는 결제 전 화면에서 보여주는 안내문구이며 같은 호텔에 여러개를 등록하여도
              하나만 보여집니다
            </p>
          </div>
          <div className="selectBoxWrap">
            <button
              className={`${noticeType === 0 && 'active'}`}
              onClick={() => onChangeNoticeType(0)}>
              공지사항
            </button>
            <button
              className={`${noticeType === 1 && 'active'}`}
              onClick={() => onChangeNoticeType(1)}>
              기상안내
            </button>
          </div>

          {noticeType === 0 ? <RenderNotice /> : <RenderWeatherNotice />}
          <Pagination pageCount={pageCount} forcePage={0} handlePageClick={pressPage} />
        </div>
      </div>
    </Style>
  );
};

export default NoticeIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .wrap {
    display: flex;
    justify-content: center;
    min-height: 100dvh;
    background: #f7f7f7;
  }

  .contentContainer {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 800px;
    min-height: 100dvh;
    height: 100%;
    padding: 4% 6%;
    background: #ffffff;
    border-radius: 10px;
    .backButton {
      width: fit-content;
      padding: 0;
      margin-top: -2%;
      margin-left: -8%;
    }
  }

  button {
    padding: 4px;
    border: none;
    background: none;
  }

  .addButton {
    width: 100%;
    background: #ffffff;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin: 10px 0;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .noticeList {
    flex: 1;
    max-height: 70dvh;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;
    overflow-y: auto;

    .row {
      gap: 6px;
    }
    .row.gap {
      gap: 14px;
    }

    .listItem {
      .itemTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 16px;
        background: #ecf5f3;
        border: 1px solid #ecf5f3;
        border-radius: 5px 5px 0 0;
        h3 {
          color: #555555;
          font-weight: 600;
        }
      }
      .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        border: 2px solid #ecf5f3;
        border-top: none;
        border-radius: 0 0 5px 5px;
      }

      h4 {
        color: #555555;
        font-weight: 500;
        white-space: nowrap;
      }
      .dot {
        width: 16px;
        height: 16px;
        border-radius: 50px;
        background: #4dd2ae;
      }
      .dot.pause {
        background: #ff6060;
      }
    }
  }

  .noticeList.none {
    align-items: center;
    justify-content: center;
    overflow: hidden;
    h3 {
      color: #555555;
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    button {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    button:nth-child(1) {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    button:nth-child(2) {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    button.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .warningSign {
    padding: 4px 0;
    display: flex;
    align-items: flex-start;
    gap: 6px;

    p {
      font-size: 14px;
      line-height: 16px;
      margin: 0;
      color: #979797;
    }
    span {
      font-size: 12px;
      color: #979797;
      font-weight: 400;
    }
  }

  @media (max-width: 800px) {
    .contentContainer {
      width: 100%;
      margin: 0 auto;
      height: 100dvh;
      padding: 4%;
      background: #ffffff;
      border-radius: 10px;
      .backButton {
        margin-top: -2%;
        margin-left: -4%;
      }
    }

    .noticeList {
      gap: 20px;

      .listItem {
        h3 {
          font-size: 16px;
          color: #555555;
          font-weight: 600;
        }
      }
    }
  }
`;
